import { Typography } from "antd";
import React from "react";
const { Title } = Typography;
export const MyTitle = ({ level = 5, text = "", textAlign = "" }) => {
  return (
    <Title level={level} style={{ textAlign: textAlign }}>
      {text}
    </Title>
  );
};
